import gql from 'graphql-tag';
import { PROJECT_ELECTRICIAN_FIELDS } from '@/store/projectElectricianFragment';

/**
 * Data of the block project-rough-planning ("Grobplanung"): electrician, the two installation
 * dates, the requirement lists for the markers NA and IN, and the electricians of the project's
 * organization as options. The electrician uses the fragment of the project page, so a block save
 * leaves no values of the previous electrician in the stored project. Read through
 * `Project.blocks.roughPlanning`, which checks the block's read permission.
 */
export const PROJECT_ROUGH_PLANNING_FIELDS = gql`
  fragment projectRoughPlanningFields on ProjectRoughPlanningBlock {
    id
    number
    electrician {
      ...projectElectricianFields
    }
    electricianOptions {
      id
      number
      name
    }
    installation {
      operationRegistrationAt
      electricMeterChangedAt
    }
    netRegistrationRequirements {
      name
      fullfilledState
    }
    operationRegistrationRequirements {
      name
      fullfilledState
    }
  }
  ${PROJECT_ELECTRICIAN_FIELDS}
`;
